import React, { useEffect, useState } from "react";
import { getAccessToken } from "../../../storage/storage";
import axios from "axios";
import { TableSkelton2 } from "../../../components/Skeletons";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
const Properties = () => {
  const token = getAccessToken();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null); // Store selected row data
  const companyInfo = JSON.parse(sessionStorage.getItem("companyInfo"));

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/api/properties/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setLoading(false);
      });
  }, []);

  const navigate = useNavigate();

  const handleOpenModal = (company) => {
    setSelectedCompany(company);
    sessionStorage.setItem("edit", "true");
    navigate("/property", { state: { company } });
  };

  return (
    <>
      <div className="flex justify-between  items-center mb-2 ml-2">
        <h1 className="font-semibold text-2xl pb-4 pt-4">Properties</h1>

        {/* <Link
          to={companyInfo ? "/lodgify/2" : "#"}
          className={`bg-[#586989] text-white px-5 py-2 rounded-md md:flex items-center justify-center hidden mr-2 ${!companyInfo ? "opacity-50 cursor-not-allowed" : ""
            }`}
          style={!companyInfo ? { pointerEvents: 'none' } : {}}
        >
          + Import Property
        </Link> */}

        <Link
          to="/lodgify/2"
          className="bg-[#586989] text-white px-5 py-2 rounded-md md:flex items-center justify-center hidden mr-2"
        >
          + Import Property
        </Link>
      </div>

      <div className="border border-[#DFDFDF] bg-white rounded-lg shadow-md overflow-x-auto w-full h-[70vh] max-w-auto">
        <table className="w-full min-w-[600px]">
          {/* Table Head */}
          <thead className="bg-[#FFF5CE] text-[#586989] font-medium text-[14px] md:text-[16px]">
            <tr>
              <th className="py-6 px-4 min-w-[150px] text-center">PID</th>
              <th className="py-6 px-4 min-w-[150px] text-center">PMS ID</th>
              <th className="py-6 px-4 min-w-[150px] text-center">Name</th>
              <th className="py-3 px-4 min-w-[150px] text-center">Company</th>
              <th className="py-3 px-4 min-w-[150px] text-center">Access instructions</th>
              <th className="py-3 px-4 min-w-[150px] text-center">City</th>
              <th className="py-3 px-4 min-w-[150px] text-center">Country</th>
              <th className="py-3 px-4 min-w-[150px] text-center">Action</th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {loading ? (
              <TableSkelton2 />
            ) : data.length > 0 ? (
              data.map((row, index) => (
                <tr
                  key={index}
                  className="bg-white text-[#1B1E27] border-t border-t-[#DFDFDF] text-left text-[12px] md:text-[16px]"
                >
                  <td className="px-4 py-6 text-center">{row.id}</td>
                  <td className="px-4 py-6 text-center">{row.lodgify_id}</td>
                  <td className="px-4 py-6 text-center">{row.name}</td>
                  <td className="px-4 py-6 text-center">{row.company}</td>
                  <td className="px-4 py-6 text-center">{row.access_instructions}</td>
                  <td className="px-4 py-6 text-center">{row.city}</td>
                  <td className="px-4 py-6 text-center">{row.country}</td>
                  <td className="px-4 py-6 text-center">
                    <div
                      className="flex items-center justify-center cursor-pointer"
                      onClick={() => handleOpenModal(row)}
                    >
                      <MdOutlineRemoveRedEye />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="7"
                  className="text-center py-20 text-lg font-bold text-[#586989]"
                >
                  No Properties found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Properties;
